module.exports = __webpack_public_path__ + "static/media/codenya.08dd3b63.png";